<div class="pddj-info">
    <h2 class="col-lg-12 col-sm-12 mx-auto d-flex justify-content-center pddjStatus">Ready For Print Job</h2>
</div>
